import type { AnatomyPart, AnatomyState } from "./componentAnatomy";

// Parts and states of the Picker anatomy, mined from
// designSystem/Picker/Picker.module.scss, PickerElementTrigger.module.scss and
// PickerItem.module.scss. The interaction state drives the trigger and the first item together: hover is
// the trigger's :hover and the item's [data-highlighted], pressed is :active on
// both, focus is the trigger ring, disabled is the root's disabled prop.

export const pickerAnatomyParts: readonly AnatomyPart[] = [
    {
        id: "border",
        label: "Trigger border",
        element:
            "1px border on the trigger Button (primary md by default), via --button-border",
    },
    {
        id: "background",
        label: "Trigger background",
        element: "background on the trigger Button, via --button-bg",
    },
    {
        id: "label",
        label: "Trigger label",
        element: ".buttonTriggerLabel (BreakableText), via --button-fg",
    },
    {
        id: "glyph",
        label: "Chevron",
        element: ".buttonTriggerIcon, rotates 180deg while [data-popup-open]",
    },
    {
        id: "surface",
        label: "Popup surface",
        element:
            ".popup: fill, 1px border, radius, shadow (--shadow-3 on a flyout level); rows 4px inside the border on every side (search bar bleeds over the top inset); children 4px apart",
    },
    {
        id: "section",
        label: "Section",
        element:
            ".section / .list inset: rows 4px in from the popup border, 2px apart",
    },
    {
        id: "itemBackground",
        label: "Item background",
        element: ".item, 28px row with --radius-xs",
    },
    {
        id: "itemLabel",
        label: "Item label",
        element: ".itemLabel, single line with ellipsis",
    },
    {
        id: "indicator",
        label: "Selected indicator",
        element:
            ".itemIndicator (16px CheckIcon) or the CheckboxIndicator under multiple",
    },
    {
        id: "sectionTitle",
        label: "Section title",
        element: ".sectionTitle (Base UI GroupLabel), 28px",
    },
    {
        id: "separator",
        label: "Separator",
        element:
            ".separator, full width between the popup borders, 4px above and below",
    },
    {
        id: "connector",
        label: "Tree connector",
        element:
            ".treeConnector[data-tree-position], one per depth whose line runs through the row",
    },
];

export const pickerAnatomyStates: readonly AnatomyState[] = [
    { id: "resting", label: "Default", selector: "" },
    {
        id: "hover",
        label: "Hover",
        selector: " .item[data-highlighted]:not([data-disabled])",
    },
    {
        id: "pressed",
        label: "Pressed",
        selector: " .item:active:not([data-disabled])",
    },
    { id: "focus", label: "Focus", selector: " .buttonTrigger:focus-visible" },
    { id: "disabled", label: "Disabled", selector: " .item[data-disabled]" },
];
